import { render, staticRenderFns } from "./questionModal.vue?vue&type=template&id=6a1f393d&scoped=true"
import script from "./questionModal.vue?vue&type=script&lang=ts"
export * from "./questionModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1f393d",
  null
  
)

export default component.exports